// Beta launch configuration. Bump `bannerVersion` whenever the message changes
// so the banner reappears for users who previously dismissed it.
export const BETA_BANNER = {
  bannerVersion: "1",
  message:
    "Welcome to the CBR Beta — you're exploring an early version of the platform. Features are still evolving, and your feedback shapes what comes next.",
};

export const APP_VERSION = process.env.REACT_APP_APP_VERSION || "0.9.0";
